import { lazy } from 'react';

export const SimilarProductsJobDetailsPageAsync = lazy(
  () => import('./SimilarProductsJobDetails'),
);
